import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[Latitude]' })
export class LatitudeDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event) {
    const regEx = /^[+-]?(([1-8]?[0-9])(\.[0-9]{1,6})?|90(\.0{1,6})?)$/;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[Longitude]' })
export class LongitudeDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event) {
    const regEx = /^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)|180(\.0{1,6})?)$/;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}
